export const SET_USER = "SET_USER";
export const SET_PLAYING = "SET_PLAYING";
export const SET_CURRENT_SONG = "SET_CURRENT_SONG";
export const SET_DISCOVER_WEEKLY = "SET_DISCOVER_WEEKLY";
export const SET_PLAYLIST = "SET_PLAYLIST";
export const SET_PLAYLISTS = "SET_PLAYLISTS";
export const SET_TOP_ARTISTS = "SET_TOP_ARTISTS";
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_MY_RECENT_PLAYED = "SET_MY_RECENT_PLAYED";
export const SET_CURRENT_TAB = "SET_CURRENT_TAB";
export const IS_LOADING = "IS_LOADING";
export const CLEAR_PLAYLIST = "CLEAR_PLAYLIST";
export const SET_CURRENT_PLAYLIST_SONGS = "SET_CURRENT_PLAYLIST_SONGS";
export const SET_CURRENT_COLOR = "SET_CURRENT_COLOR";
export const SET_IS_PLAYING = "SET_IS_PLAYING";
export const SET_IS_AUTOPLAY = "SET_IS_AUTOPLAY";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
